import loadable from '@loadable/component';
import { getLogger } from '@cian/logger/shared';

export const GenplanLoadable = loadable(() =>
  import('./Genplan').catch(error => {
    getLogger().error(error, { domain: 'GenplanLoadable' });

    return { default: () => null };
  }),
);
